import React from "react";
import { shallowEqual } from "react-redux";
import Text from "../../../../../shared-components/css-modules/lexus/atoms/Text";
import styles from "./Summary.module.scss";
import { useCarConfigSelector } from "../../../../redux/store";
import { useTabsContext } from "./SummaryTabsContext";
import InsurancePrice from "../price/InsurancePrice";
import { CarConfigLabel } from "../../../../utils/labelUtils";
import { pricingDetailsSelector } from "../../../../utils/selectorUtils";
import SummaryTotalOverview from "./SummaryTotalOverview";

const SummaryTotals: React.FC = () => {
    const tabsContext = useTabsContext();
    const { hideFinanceDetailsSummaryFooter } = useCarConfigSelector(pricingDetailsSelector, shallowEqual);

    if (tabsContext.openTab === "insurance") {
        return (
            <ul role="list" className={styles["config-sublist"]}>
                {/*Total cash prices*/}
                <li className={styles["config-subitem-total"]}>
                    <Text tag="h4" variant="apheleia-body-large">
                        <CarConfigLabel label="carConfigInsuranceTotal" />
                    </Text>
                    <Text tag="h4" variant="apheleia-body-large" className={styles["config-subitem-price"]}>
                        <InsurancePrice />
                    </Text>
                </li>
                <li>
                    <div className={styles.disclaimer}>
                        <CarConfigLabel label="carConfigInsuranceTabServicesDisclaimer" />
                    </div>
                </li>
            </ul>
        );
    }

    if (!hideFinanceDetailsSummaryFooter && tabsContext.openTab !== "business")
        return (
            <ul role="list" className={styles["config-sublist"]}>
                {/*Total cash prices*/}
                <li className={styles["config-subitem-total"]}>
                    <SummaryTotalOverview />
                </li>
            </ul>
        );

    // Return null if neither conditions match because we don't want to render
    // anything to keep footer compact
    return null;
};

export default SummaryTotals;
